import React from "react";
import { Box, Card, CardContent, Typography, Button, Stack } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const DeleteConfirmAlert = ({
  message = "Are you sure you want to delete this record?",
  onOk,
  onCancel,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 320,
          borderRadius: 4,
          textAlign: "center",
          p: 3,
        }}
      >
        <CardContent>

          <DeleteForeverIcon
            sx={{
              fontSize: 70,
              color: "error.main",
              mb: 2,
            }}
          />

          <Typography variant="h6" fontWeight="bold">
            Confirm Delete
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            {message}
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color="error"
              fullWidth
              onClick={onOk}
              sx={{ borderRadius: 3 }}
            >
              OK
            </Button>

            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={onCancel}
              sx={{ borderRadius: 3 }}
            >
              Cancel
            </Button>
          </Stack>

        </CardContent>
      </Card>
    </Box>
  );
};

export default DeleteConfirmAlert;